import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { AppWizardComponent } from './views/pages/app-wiz/app-wiz.component';
import { CertWizardComponent } from './views/pages/cert-wizard/cert-wizard.component';
import { HelpComponent } from './views/pages/help/help.component';

import { HomePageComponent } from './views/pages/home-page/home-page.component';
import { LoginComponent } from './views/pages/public/login/login.component';
import { MessageCenterComponent } from './views/partials/message-center/message-center.component';
import { LayoutComponent } from './views/themes/layout/layout.component';
import { PaymentComponent } from './views/partials/payment/payment.component';
import { PaymentErrorComponent } from './views/partials/payment-error/payment-error.component';
import { StandalonePaymentComponent } from './views/partials/standalone-payment/standalone-payment.component';
import { StandalonePaymentConfirmationComponent } from './views/partials/standalone-payment/standalone-payment-confirmation.component';
import { SupportComponent } from './views/pages/support/support.component';
import { RoleGuard } from './core/guards/role.guard';
import { ROLES_BY_USER_TYPE } from './core/enums/ui.enum';
import { BrowserSupportGuard } from './core/guards/browser-support.guard';
import { BrowserCheckComponent } from './shared/components/general/browser-check/browser-check.component';
import { ScheduledMaintenanceComponent } from './shared/components/general/scheduled-maintenance/scheduled-maintenance.component';
import { PdfSummaryComponent } from './views/pages/pdf-summary/pdf-summary.component';

const routes: Routes = [
  { 
    path: 'app/auth/login', 
    component: LoginComponent,
    canActivate: [BrowserSupportGuard],
  },
  {
    path:'app',
    component:LayoutComponent,
    canActivate: [BrowserSupportGuard],
    children:[
      { 
        path: '', 
        component: HomePageComponent,
        canActivate: [AuthGuard, RoleGuard], 
        data: { roles: ROLES_BY_USER_TYPE.APPLICANT },
      },
      { path: 'cert-wizard', component: CertWizardComponent, canActivate:[AuthGuard] },
      { path: 'app-wizard/:appId', component: AppWizardComponent, canActivate:[AuthGuard] },
      { path: 'message-center', component: MessageCenterComponent, canActivate:[AuthGuard] },
      { path: 'payment', component: PaymentComponent, canActivate:[AuthGuard] },
      { path: 'payment/error', component: PaymentErrorComponent, canActivate:[AuthGuard] },
      { path: 'standalone-payment', component: StandalonePaymentComponent, canActivate:[AuthGuard] },
      { path: 'standalone-payment/confirmation', component: StandalonePaymentConfirmationComponent, canActivate:[AuthGuard] },
      { path: 'help', component: HelpComponent },
      { path: 'pdf-summary', component: PdfSummaryComponent },
      { path: 'user-guides', redirectTo: 'help', pathMatch: 'full' },
      { path: 'support', component: SupportComponent },
      // { path: 'auth/login', redirectTo:"/auth/login" },
      { path: '**', redirectTo:"" },
    ]
  },
  {
    path:'edu-agent',
    canActivate: [BrowserSupportGuard],
    loadChildren: () => import('./edu-agent/edu-agent.module').then(m => m.EduAgentModule)
  },
  { 
    path: 'idscan', 
    loadChildren: () => import('./idscan/idscan-routing.module').then(m => m.IdscanRoutingModule)
  },
  { 
    path: 'browser-check', 
    component: BrowserCheckComponent,
  },
  { 
    path: 'scheduled-maintenance', 
    component: ScheduledMaintenanceComponent,
  },
  {
    path: "**",
    redirectTo:"/app"
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
